/* Refillia: da telefono ogni riga che scorre di lato ha sotto la sua linea, come "I più presi" */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var SALTA = '#header-component, .rfch, .rf-foglio, .rf-mega, cart-drawer, .rfc-cassetto, .search-modal, dialog, [data-rf-no-linea]';
  var righe = [];

  function scorre(el) {
    var c = getComputedStyle(el);
    return (c.overflowX === 'auto' || c.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 8 && el.clientWidth > 0;
  }
  function haGia(el) {
    var p = el.parentElement;
    if (!p) return true;
    // una riga che ha già la sua linea (qualsiasi classe con "scorri" o "linea" accanto) non ne riceve una seconda
    var dopo = el.nextElementSibling;
    return !!(p.querySelector(':scope > [data-rf-scorri], :scope > .rf-scorri, :scope > .rf-pdp__benlinea, :scope > .rf-linea, :scope > [class*="scorri"]') ||
      (dopo && /(^|[-_\s])(linea|scorri)/.test(dopo.className || '')));
  }
  function aggiungi(el) {
    if (el.dataset.rfLinea || el.closest(SALTA) || haGia(el)) return;
    el.dataset.rfLinea = '1';
    var barra = document.createElement('div');
    barra.className = 'rf-linea';
    barra.setAttribute('aria-hidden', 'true');
    barra.innerHTML = '<i></i>';
    var dopo = el, p = el.parentElement, cp = getComputedStyle(p);
    // in una riga flex la linea andrebbe di fianco: si sale finché il contenitore non è una colonna
    while (p && p !== document.body && cp.display.indexOf('flex') >= 0 && cp.flexDirection.indexOf('row') === 0) {
      dopo = p; p = p.parentElement; cp = getComputedStyle(p);
    }
    if (!p || p === document.body) { delete el.dataset.rfLinea; el.dataset.rfLinea = 'no'; return; }
    if (cp.display.indexOf('grid') >= 0) {
      // dentro una griglia di schede prodotto la linea non va: sembrerebbe una scheda
      if (p.children.length > 4 && dopo !== el) { el.dataset.rfLinea = 'no'; return; }
      barra.style.gridColumn = '1 / -1';
      if (parseFloat(cp.rowGap) > 0) barra.style.margin = '0';
    }
    dopo.insertAdjacentElement('afterend', barra);
    var fondo = barra.parentElement, colore = '';
    while (fondo) { colore = getComputedStyle(fondo).backgroundColor; if (colore && colore !== 'rgba(0, 0, 0, 0)' && colore !== 'transparent') break; fondo = fondo.parentElement; }
    var n = (colore.match(/\d+/g) || [255, 255, 255]).map(Number);
    if ((n[0] * 299 + n[1] * 587 + n[2] * 114) / 1000 < 110) barra.classList.add('rf-linea--scura');
    var cursore = barra.firstChild;
    function aggiorna() {
      var tot = el.scrollWidth, vis = el.clientWidth;
      barra.hidden = !mq.matches || tot <= vis + 8 || el.offsetParent === null;
      if (barra.hidden) return;
      var w = Math.min(0.25, 120 / Math.max(1, barra.clientWidth)), x = el.scrollLeft / Math.max(1, tot - vis);
      cursore.style.width = (w * 100) + '%';
      cursore.style.left = (Math.min(1, x) * (1 - w) * 100) + '%';
      // a fine corsa la dissolvenza a destra non serve più
      el.classList.toggle('rf-alla-fine', x > 0.97);
    }
    el.addEventListener('scroll', aggiorna, { passive: true });
    barra.addEventListener('click', function (e) {
      var r = barra.getBoundingClientRect();
      el.scrollTo({ left: (e.clientX - r.left) / r.width * (el.scrollWidth - el.clientWidth), behavior: 'smooth' });
    });
    righe.push(aggiorna);
    aggiorna();
  }
  // radici da esaminare: tutta la pagina all'avvio e al resize, poi solo i pezzi aggiunti
  var daVedere = [], tutto = true;
  function cerca() {
    if (!mq.matches) { daVedere = []; tutto = false; righe.forEach(function (f) { f(); }); return; }
    var radici = tutto ? [document.querySelector('main'), document.querySelector('.shopify-section-group-footer-group')] : daVedere;
    daVedere = []; tutto = false;
    // prima tutte le letture, poi le scritture: il layout si calcola una volta sola
    var trovati = [];
    radici.forEach(function (r) {
      if (!r || !r.isConnected) return;
      var lista = [r].concat(Array.prototype.slice.call(r.querySelectorAll('*')));
      for (var i = 0; i < lista.length; i++) {
        var el = lista[i];
        if (el.children.length < 2 || el.dataset.rfLinea) continue;
        // scrollWidth costa poco; lo stile calcolato si chiede solo a chi è davvero più largo
        if (el.scrollWidth <= el.clientWidth + 8 || el.clientWidth === 0) continue;
        if (scorre(el)) trovati.push(el);
      }
    });
    trovati.forEach(aggiungi);
    righe.forEach(function (f) { f(); });
  }
  var attesa;
  function presto() { clearTimeout(attesa); attesa = setTimeout(cerca, 250); }
  function daCapo() { tutto = true; presto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', daCapo); else daCapo();
  window.addEventListener('load', daCapo);
  window.addEventListener('resize', daCapo);
  document.addEventListener('shopify:section:load', daCapo);
  // righe che arrivano dopo (filtri, risultati, schede caricate): contano solo gli elementi aggiunti,
  // non le scritte che cambiano (orologi, animazioni)
  if ('MutationObserver' in window) {
    new MutationObserver(function (lista) {
      var c = false;
      for (var i = 0; i < lista.length; i++) {
        var add = lista[i].addedNodes;
        for (var j = 0; j < add.length; j++) {
          var el = add[j];
          if (el.nodeType !== 1 || el.classList.contains('rf-linea')) continue;
          daVedere.push(el.parentElement || el); c = true;
        }
      }
      if (c) presto();
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
})();
